import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default props => (
  <>
    <Container
      id="main-box"
      xl={{ span: 4, offset: 4 }}
      lg={{ span: 6, offset: 3 }}
      md={{ span: 8, offset: 2 }}
      sm={{ span: 6, offset: 3 }}
    >
      <Row>
        <Col>
          <p>
            <h4>Terms and Conditions</h4>
          </p>
          <p>This website, the Hospice Preparation and Education (HoPE) tool and any and all content or services available on or
          through this website are provided for general, noncommercial informational purposes only, and do not constitute the
          practice of medical or any other professional judgment, advice, diagnosis or treatment, and should not be considered
          or used as a substitute for the independent professional judgment, advice, diagnosis or treatment of a duly licensed
  and qualified healthcare provider.</p>
          <p>In case of a medical emergency, you should immediately call 911.</p>
          <p>
            Thank you for using the web site located at <a href="https://myhopeplan.org">https://myhopeplan.org</a> (“Site”),
  which is owned and provided by Duke University. The Site is provided solely to individual third party users over the
  age of 18 (“Users”). The terms and conditions set forth below (the “Agreement”) govern your access to and use, as a
  User, of the Site. By accessing or using the Site or viewing, downloading or using any information contained, linked
  or otherwise accessible on or through it (“Content”), you expressly agree to be bound by this Agreement and to abide
  by its terms and conditions as well as all applicable laws, regulations and other requirements binding on you, your
  institution and/or Duke.
  <strong>Do not use the Site if you do not agree to all of the terms and conditions of this Agreement.</strong>
          </p>
          <p>
            If you are accessing or using the Site or its Content in connection with your role as a provider of medical or other
            professional services, clinical research or any other items or services for an institution or other organization other
            than Duke (your “Institution”), then that Institution is also bound by this Agreement and you represent and warrant
            that you have the authority to accept this Agreement on behalf of that Institution.
</p>
          <p>
            Duke University may revise and update this Agreement at any time. Accordingly, we suggest that you check the Site
            periodically for any such updates. Your continued usage of the Site after such updates means you accept those updates.
</p>
          <p>
            1. Intellectual Property
</p>
          <p>
            The Site and all associated Content, software (in both source code and object code format), materials, images,
            graphics, logos, illustrations, photographs, video, audio, graphical elements, look and feel, structure, organization,
            design, algorithms, templates, data models, logic flow and screens, together with any and all names, brands and logos,
            and all copyrights, trademarks, service marks, trade names, trade secrets, patents and other intellectual property
            rights, title or interests associated with any of the foregoing are and shall remain the sole and exclusive property
            of Duke University or applicable third party licensors. Nothing in this Agreement transfers any of such rights, title
            or interests to any User.
</p>
          <p>
            2. Proper Use
</p>
          <p>
            Duke University grants you, as a User, permission to access and view the Site and its Content, for your personal
            general non-commercial informational purposes only. Neither the Site nor its Content are, nor are they intended to be,
            a substitute for the exercise of independent professional judgment by any healthcare provider or other professional
            (including any User), including with respect to the diagnosis or treatment of any patient, and further including
            without limitation such provider’s obligation to independently confirm the completeness and accuracy of information,
            such as any Content accessed hereunder, in accordance with generally accepted standards of good medical practice
            applicable to the provider’s profession in the applicable jurisdiction(s). Duke is not and shall not be responsible or
            liable for any such medical care or other professional services rendered by any User to any person or entity.
</p>
          <p>
            The Site and its Content are provided solely to Users over the age of 18. Duke cannot prohibit minors from visiting
            the Site or viewing its Content, however, and accordingly must rely on parents, guardians and other adults responsible
            for supervising minors to decide whether the Site or its Content is appropriate for their use or review.
</p>
          <p>
            You agree that you will not copy, reproduce, alter, modify, create derivative works from, or publicly display any
            Content, including without limitation any trademarks or service marks, without prior written permission from Duke
            University or the applicable third party licensor. You agree not to change or delete any proprietary notices from any
            Content downloaded or copied from the Site. You further agree not to, or permit others to, decompile, disassemble or
            otherwise reverse engineer or attempt to reconstruct or discover any source code related to the Site. Youalso agree
            that you will not use any robot, spider, or automated device, or manual process to monitor or copy any Content from
            the Site. Further, any use of the Site or its Content that infringes on the intellectual property rights of Duke or
            its third party licensors, or that is for any purpose not expressly permitted in this Section 2, may be investigated,
            and Duke shall have the right to take or instigate appropriate civil and criminal legal action to enforce Duke’s
            and/or its third party licensors’ respective rights and obtain any and all remedies available hereunder or otherwise
            at law or equity.
</p>
          <p>
            If you violate this Agreement, your permission to use the Site and its Content automatically terminates
            and you must immediately destroy any copies you have made of any portion of the Content.
</p>
          <p>
            3.
            User Contributions;
            User Agreements
</p>
          <p>
            Duke encourages constructive community comments, suggestions and feedback on the Site and the Content, and may allow
            you to post, upload, or otherwise submit material on the Site (“Submissions”). You grant Duke the right, in its sole
            discretion, to use, copy, distribute, transmit, publicly display, publicly perform, reproduce, edit, translate and
            reformat Submissions: (a) to modify, improve, deliver, and market the Site and the Content, and (b) in connection with
            other Duke electronic and print materials and publications, for purposes consistent with Duke’s charitable mission.
            This right includes, without limitation, the right for Duke to publish your name in connection with Submissions and
            the right to sublicense such rights as necessary to provide the Site.
            Any Submissions should and will be offered by you without expectation of compensation, partnership, or recognition by
            Duke or its third party licensors. Duke shall have the right to retain and use any such information without
            compensation to you or your Institution or employer.
</p>
          <p>
            You agree to use the Site and its Content for the proper uses set forth in this Agreement. By way of example, and not
            as a limitation, you agree not to post Submissions or access or use the Site or its Content to do any of the
            following:
</p>
          <ul>
            <li>
              To engage in unlawful activity;
  </li>
            <li>
              To conduct or further any survey, contest, pyramid scheme or chain letter; to engage in spamming or to forward junk
              email or other duplicative or unsolicited commercial or other messages; to advertise or otherwise solicit business;
              or to use, download or copy, or provide to any other person or entity third-party User or Site usage information or
              any portion thereof;
  </li>
            <li>
              To upload, post, publish, transmit, distribute or disseminate or otherwise make available any communication,
              material or content of any type that is, or which Duke determines in its sole discretion to be, inappropriate,
              profane, defamatory, slanderous, obscene, indecent, hateful, abusive, threatening, harassing or unlawful;
  </li>
            <li>
              To upload files or other materials or information that may contain viruses, malware, spyware, Trojan horses, worms,
              time bombs, cancelbots, corrupted files, or any other contaminating or destructive software or programs or code; or
              to disable, “hack” or otherwise interfere with the proper functioning of, or to restrict or inhibit another user
              from accessing or using the Site or its Content; or
  </li>
            <li>
              To impersonate someone else or to create a false identity to mislead others.
  </li>
          </ul>
          <p>
            4. Warranty
</p>
          <p>
            Neither the Site nor its Content is, nor should they be viewed as, the sole source of information on the matters
            addressed therein. While the Content may be periodically updated, no guarantee is given that such information is
            correct, complete, or up-to-date.In any event the site and content are made available only for appropriate access and
            use only, on an “as is” basis, with no warranty of any kind. All access to, and/or use or further disclosure of, the
            site and content is entirely at users’ own risk. Neither Duke nor any of its or their trustees, directors, officers,
            members, faculty, medical staff, employees, agents or contractors (collectively, the “Duke Representatives”) have made
            or are making, and all of the foregoing hereby disclaim, any warranties or guarantees with respect to the site or
            content, whether pursuant or statutory or common law, express or implied, including without limitation as to ease of
            or secure, timely or continuous access to, or as to freedom from any possible consequences such as loss of data or
            viruses or any other contamination or destructive software or programs or code arising from or in connection with such
            access to or use of, or otherwise as to merchantability, accuracy, completeness, adequacy, timeliness,
            non-infringement or fitness for any particular purpose of, the site or content. Users and their respective
            institutions solely assume all risk associated with possible loss, destruction, inaccuracy, incompleteness,
            untimeliness or corruption of their data, intentional intrusion, unauthorized access, use or disclosure, failure or
            delay and interruption arising out of, in connection with or otherwise relating in any way to, the access or use of
            the site or content.
</p>
          <p>
            5. Limitation of Liability
</p>
          <p>
            Neither Duke nor any of the Duke Representatives, has or shall have, and all of the foregoing hereby expressly
            disclaim, any and all responsibility or liability of any kind to a User, any Institution or any third party resulting
            from, arising out of, relating to or otherwise connected in any way with any use of, reference to, or reliance on the
            Site or Content by Users, any Institution or any third party.
</p>
          <p>
            To the maximum extent permitted by applicable law, you, on your own behalf and that of your Institution (and that of
            any others who may claim by or through any of the foregoing), hereby release, and waive all claims against Duke and
            the Duke Representatives from any and all liability for any and all claims, suits, damages, fines, penalties, costs,
            expenses (including costs and attorneys’ fees) or other losses of any kind or nature (“Loss”), arising out of or in
            any way connected with you or your Institution’s or any third party’s access to or use or disclosure of the Site or
            its Content, whether or not Duke has been advised of the possibility of such Loss. Users who are California residents
            hereby waive any rights under California Civil Code sec. 1542; Users who are residents of other states and nations
            similarly waive on their behalf, that of their Institution (and that of any others who may claim by or through any of
            the foregoing) any and all similar rights under applicable or analogous laws, statutes, regulations or other binding
            legal authorities.
</p>
          <p>
            6. Hold Harmless and Indemnification
</p>
          <p>
            By accessing the Site or Content, you, on your behalf and that of your Institution (and that of any others who may
            claim by or through any of the foregoing), hereby waive all claims for, and agree to indemnify and hold harmless Duke
            and the Duke Representatives from and against, any and all claims, or Loss arising out of or in connection with your
            access to or use or disclosure of the Site or Content and your other acts or omissions arising out of or in connection
            with this Agreement, whether or not Duke has been advised of the possibility of such Loss. You agree that you and your
            Institution alone are responsible for your use of the Site.
</p>
          <p>
            If you are affiliated with an Institution providing medical services, you and/or your Institution shall maintain in
            force at your or its sole cost and expense, with reputable insurance companies, insurance of a type and in an amount
            reasonably sufficient to protect against liability for any such Loss and to meet your indemnification obligations
            hereunder.
</p>
          <p>
            7. Privacy and Security
</p>
          <p>
            Duke University is committed to protecting your online privacy. All personally identifiable data that you enter on the
  Site is not sold to any third parties. Please visit <a
              href="https://www.dukehealth.org/privacy/website-privacy-policy">https://www.dukehealth.org/patients-and-visitors/privacy/website-privacy...</a>
  for the Site’s full privacy policy, which is incorporated herein by reference.
</p>
          <p>
            8. Links to other sites
</p>
          <p>
            The Site may include links providing access to other Internet resources, including other web sites. However, Duke is
            not responsible for the accuracy or content of information contained in these sites. Links from the Site to
            third-party sites and resources do not constitute an endorsement by Duke of the parties or their products and
            services. The appearance of advertisements and product or service information does not constitute an endorsement by
            Duke, and Duke has not investigated the claims made by any advertiser. Product information is based solely on material
            received from suppliers.
</p>
          <p>
            9. Links to this Site
</p>
          <p>
            Duke University grants you a limited, non-exclusive, revocable, non-assignable, personal, and non-transferable license
            to create hyperlinks to the Site under the following conditions: a) the links and the content on your website must not
            suggest any affiliation with or endorsement by Duke or cause any other confusion regarding your relationship to Duke
            or its online services; b) the link opens to the full version of applicable web page, and each page within the Site is
            displayed in full (including all trademarks and branding), unaltered, and without any accompanying frame, border,
            margin, design, branding, trademark, advertising, or promotional materials not originally displayed on the page within
            the Site; and c) the links and content on your website do not portray Duke or any Duke Representatives in a false,
            misleading, derogatory, or otherwise offensive matter, and do not contain content that is unlawful, offensive,
            obscene, threatening, harassing, or that violates this Agreement or any right of any third party or is otherwise
            objectionable to Duke. Duke reserves the right to suspend, withdraw permission, or prohibit linking to its web pages
            and/or online services for any reason, in its sole discretion, without advance notice or any liability to any kind to
            you or any third party. Unless Duke University enters into a specific written agreement with you, you may not use any
            of Duke’s names, logos, designs, slogans, trademarks, or service marks in or with your links, except that you may link
            to the Site using the plain text name of the Site.
</p>
          <p>
            10. Violations of Terms
</p>
          <p>
            In addition to any legal remedy that Duke may have hereunder or otherwise at law or equity for your violation of the
            terms of this Agreement, Duke shall also have the right in its sole discretion to immediately suspend or terminate
            your access to and/or use of the Site and its Contents.
</p>
          <p>
            11. No Assignment
          </p>
          <p>
            You shall not assign this Agreement or assign any of your rights or delegate any of your obligations hereunder, in
            whole or in part, whether voluntarily or by operation of law, without Duke University’s prior written consent. Any
            such purported assignment or delegation without Duke University’s prior written consent will be null and void and of
            no force or effect.
          </p>
          <p>
            12. Relationship of the Parties
          </p>
          <p>
            It is expressly understood that each party to this Agreement is an independent contractor, and that nothing herein
            shall be construed as creating a partnership, joint venture, agency, or employment relationship between you or your
            Institution and Duke. Neither you nor your Institution shall have any right, power or authority, express or implied,
            to bind Duke. Nothing in this Agreement is intended, nor shall be deemed, to confer any obligation to, or to confer
            any rights or any benefits on, any non-party.
          </p>
          <p>
            13. Additional Resources
          </p>
          <p>
            There may be additional sites, services and/or software linked to or offered by Duke via the Site (“Additional
            Resources”). These Additional Resources may or may not have their own terms of use and agreements that contain
            additional or different terms and requirements than those set forth in this Agreement. You are advised to check for
            and review the agreements associated with these Additional Resources. In the event of a conflict between the terms of
            this Agreement and the terms of the Additional Resources, the terms of the Additional Resources shall govern with
            respect to use or access of such Additional Resources.
          </p>
          <p>
            14. Copyright Policies
          </p>
          <p>
            Duke University complies with the provisions of the Digital Millennium Copyright Act (DMCA). If you have a concern
            regarding the use of copyrighted material on the Site, please contact the agent designated to respond to reports
            alleging copyright infringement:
          </p>
          <p>
            <div>Richard Biever</div>
            <div>Digital Millenium Copyright Act Agent</div>
            <div>334 Blackwell Street</div>
            <div>Suite 2106</div>
            <div>Durham, NC 27701</div>
            <div>E-mail (preferred): <a href="mailto:dmca-agent@duke.edu">dmca-agent@duke.edu</a></div>
            <div>Phone: 919.684.8121</div>
          </p>
          <p>
            The Digital Millennium Copyright Act specifies that all infringement claims must be in writing (either electronic mail
            or paper letter) and must include the following elements:
          </p>
          <p>
            <div>a physical or electronic signature;</div>
            <div>identification of the infringed work;</div>
            <div>identification of the infringed material;</div>
            <div>contact information for the complainant, e.g. address, telephone number, electronic mail address;</div>
            <div>a statement that the complaining party has a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner or the law; and</div>
            <div>a statement that the information contained in the notification is accurate, and under penalty of perjury, that the complaining party is authorized to act on behalf of the copyright owner.</div>
          </p>
          <p> 15.  Miscellaneous</p>
          <p>This Agreement constitutes the entire agreement among Duke and you and (if applicable) your Institution with respect to the subject matter hereof, and all prior agreements, representations, statements and undertakings, whether oral or written, are hereby superseded and cancelled. Neither this Agreement nor any rights or obligations hereunder may be modified, amended, assigned or transferred by you or your Institution without prior written consent of Duke University. If any provision of this Agreement is held to be invalid or unenforceable by a court or other legal authority having jurisdiction over Duke University, such provision shall be deemed superseded by a valid enforceable provision that most closely matches the intent of the original provision and the remaining provisions shall be enforced. Any failure by Duke to act with respect to a breach by you or others does not waive Duke’s right to act with respect to subsequent or similar breaches. The failure of Duke to exercise or enforce any right or provision of these terms and conditions shall not constitute a waiver of such right or provision. The section headings and subheadings contained in this Agreement are included for convenience only, and shall not limit or otherwise affect the terms of this Agreement. This Agreement shall be governed by, construed, performed and enforced in accordance with the laws of the State of North Carolina, without giving effect to any choice or conflict of law provision or rule thereof. Because the Site is controlled, operated and provided by the SoM from its offices in North Carolina and are made available only for educational or informational purposes, you agree that Duke’s actions hereunder do not constitute “doing business” in any specific jurisdiction or soliciting business for Duke or any Duke Representatives, or establishing “minimum contacts” in any state outside of North Carolina. Any action or proceeding seeking to enforce, or based on any right arising out of, this Agreement, may be brought against any of the parties hereto, whether brought during the term hereof of thereafter, only in the courts of the State of North Carolina, County of Durham, or, if it has or can acquire jurisdiction, in the United States District Court for the Middle District of North Carolina, and each of the parties hereto consents to the jurisdiction of such courts (and of the appropriate appellate courts) in any action or proceeding brought hereunder and waives any objection to venue laid therein. Process in any action or proceeding referred to in the preceding sentence may be served on any party anywhere in the world. Questions regarding the Agreement should be directed to Jill Boy at <a href="mailto:jill.boy@duke.edu">jill.boy@duke.edu</a>.</p>
        </Col>
      </Row>
    </Container>
  </>
);
